import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { fmtKg } from "./MaterialPriceCell";

const ACTION = { BASE_PRICE_UPDATED: "Prezzo base modificato", ROW_ADDED: "Riga aggiunta", ROW_PRICE_UPDATED: "Prezzo riga modificato", ROW_REMOVED: "Riga eliminata" };
const when = (iso) => iso ? new Date(iso).toLocaleString("it-IT", { dateStyle: "short", timeStyle: "short" }) : "—";

/** Storico append-only delle modifiche di prezzo: valore precedente, nuovo, data e autore. */
export function MaterialPriceHistory({ material, onClose }) {
  const [rows, setRows] = useState(null);
  useEffect(() => { if (material) api.get(`/config/materials/${material.id}/price-history`).then(({ data }) => setRows(data.history)); }, [material]);
  return (
    <Dialog open={!!material} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-3xl">
        <DialogHeader><DialogTitle>Storico prezzi · {material?.name}</DialogTitle><DialogDescription>Modifiche registrate del prezzo €/kg: data, valore precedente → nuovo, autore.</DialogDescription></DialogHeader>
        <div className="text-xs max-h-[60vh] overflow-y-auto" data-testid="material-history-list">
          {(rows || []).map((h) => (
            <div key={h.id} className="border-b border-border py-2 grid grid-cols-12 gap-2" data-testid={`material-history-${h.id}`}>
              <div className="col-span-3">{when(h.at)}</div>
              <div className="col-span-3">{ACTION[h.action] || h.action}{h.row_label ? <span className="text-muted-foreground"> · {h.row_label}</span> : <span className="text-muted-foreground"> · prezzo base</span>}</div>
              <div className="col-span-3 font-mono">{h.previous != null ? fmtKg(h.previous) : "—"} → {h.new != null ? fmtKg(h.new) : "—"}</div>
              <div className="col-span-3 text-muted-foreground truncate" title={h.by?.email}>{h.by?.name || h.by?.email || "—"}</div>
            </div>
          ))}
          {rows && rows.length === 0 && <div className="py-4 text-center text-muted-foreground" data-testid="material-history-empty">Nessuna modifica registrata.</div>}
        </div>
      </DialogContent>
    </Dialog>
  );
}
